import { useState } from 'react';

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('token');
    if (!tokenString || tokenString === 'undefined' || tokenString === 'null') {
      return null;
    }
    try {
      const userToken = JSON.parse(tokenString);
      return userToken;
    } catch (error) {
      console.error('Failed to parse token:', error);
      return null;
    }
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('token', JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token
  };
}
